import { Directive } from '@angular/core';

export const overlayBoundarySelector: string = '[uiOverlayBoundary]';

@Directive({
  selector: overlayBoundarySelector,
})
export class OverlayBoundaryDirective {}
